import Api from "../apiService";

class OrderInvoiceItemsApi {
  index(companyId, orderId, invoiceId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/orders/${orderId}/invoices/${invoiceId}/invoice_items`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, orderId, invoiceId, id) {
    return Api.getRequest(
      `companies/${companyId}/orders/${orderId}/invoices/${invoiceId}/invoice_items/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, orderId, invoiceId, data) {
    return Api.postRequest(
      `companies/${companyId}/orders/${orderId}/invoices/${invoiceId}/invoice_items`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, orderId, invoiceId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/orders/${orderId}/invoices/${invoiceId}/invoice_items/${id}`,
      data,
      Api.authHeaders()
    );
  }

  delete(companyId, orderId, invoiceId, id) {
    return Api.deleteRequest(
      `companies/${companyId}/orders/${orderId}/invoices/${invoiceId}/invoice_items/${id}`,
      {},
      Api.authHeaders()
    );
  }
}

export default new OrderInvoiceItemsApi();
